module.exports = __webpack_public_path__ + "img/category_9.6a35be99.png";